var require_runtime = require('../../_virtual/_rolldown/runtime.cjs');
//#region src/types/plugins/ProvideSharedPlugin.ts
var ProvideSharedPlugin_exports = /* @__PURE__ */ require_runtime.__exportAll({});
//#endregion
Object.defineProperty(exports, 'ProvideSharedPlugin_exports', {
    enumerable: true,
    get: function get() {
        return ProvideSharedPlugin_exports;
    }
}); //# sourceMappingURL=ProvideSharedPlugin.cjs.map
